import MainCard from "@alliancesafetycouncil/asc-card";
import PageTitle from "@alliancesafetycouncil/asc-page-title";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { getAuth } from "../../../actions/Auth/Auth";

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      loginErrors: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(event) {
    const { username, password } = this.state;
    const { GetAuth, history } = this.props;

    GetAuth(username, password);
    event.preventDefault();
  }

  render() {
    const { username, password } = this.state;
    const { auth, busy, error, message } = this.props;

    return (
      <div className="sign-in container mt-8 md:w-1/2">
        <div className="mb-6 text-4xl text-center">
          <span className="font-bold text-blue-600">Ready</span>
          <span className="font-thin text-green-500">Safe</span>
        </div>
        <Form>
          <MainCard type="main">
            <PageTitle>Sign In</PageTitle>
            <p className={`form-error ${error ? "show" : ""}`}>{error}</p>
            <FormGroup>
              <Label for="exampleEmail">Email Address</Label>
              <Input
                value={username}
                onChange={this.handleChange}
                type="username"
                name="username"
                id="username"
                placeholder="Email Address"
                className="username"
              />
            </FormGroup>
            <FormGroup>
              <Label for="examplePassword">Password</Label>
              <Input
                value={password}
                onChange={this.handleChange}
                type="password"
                name="password"
                id="password"
                placeholder="Password"
                className="password"
              />
            </FormGroup>
            <Button className="sign-in button" onClick={this.handleSubmit}>
              {busy ? "Signing in..." : "Sign in"}
            </Button>
            <br></br>
            <div>
              <p>
                <a href="#/forgot-password">Forgot Password</a>
              </p>
            </div>
          </MainCard>
        </Form>
        <div>
          {/* Auth & Redirect Handler for Superadmin */}
          {auth && (
            <Redirect
              to={{
                pathname: "/favourite-sites",
                state: { from: window.location },
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authService.auth,
    busy: state.authService.busy,
    error: state.authService.error,
    message: state.authService.message,
    token: state.authService.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetAuth: (username, password) => dispatch(getAuth(username, password)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
